import React, { useEffect } from 'react';
import SmartImage from '../../subcomponents/SocialSmartImage';
import trackingFunction from '../../tracking';
import findAltText from '../../utils';
import './social.scss';

function Social({ element, url, isBootroom, campaignType, order, version }) {
  const {
    innerColor,
    outerColor,
    textColor,
    titleColor,
    mobileTextColor,
    socialNumber,
    mobileTitleColor,
    useMobileText,
    noBackground,
    backgroundColor,
    useGradient,
    backgroundGradient,
    gradientDirection,
    hide,
    type,
    anchorName
  } = element;
  const { slug, imagePattern } = url;
  const commonTranslations = window.campaign_data.common_translations.blocks;
  const uppercaseLetters = url.generalData
    ? url.generalData.uppercaseLetters
    : false;
  let displayTextColor = textColor;
  let displayTitleColor = titleColor;
  if (useMobileText && window.innerWidth < 768)
    displayTextColor = mobileTextColor;
  if (useMobileText && window.innerWidth < 768)
    displayTitleColor = mobileTitleColor;

  const classes =
    uppercaseLetters && campaignType === 'general'
      ? 'social-title title title--uppercase'
      : 'social-title title';

  // function to make anchors and the tracking events work in sale campaigns
  // this function is only on social since it is the last component that renders
  useEffect(() => {
    if (window.location.hash) {
      window.setTimeout(() => {
        // eslint-disable-next-line no-self-assign
        window.location = window.location;
      }, 0);
    }
    if (campaignType === 'sale' || campaignType === 'general') {
      setTimeout(() => {
        window.addEventListener('scroll', trackingFunction);
      }, 1000);
    }
  }, []);

  let styler = {};
  if (noBackground && useGradient && gradientDirection === 'leftToRight') {
    styler = {
      background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)`
    };
  } else if (
    noBackground &&
    useGradient &&
    gradientDirection === 'topToBottom'
  ) {
    styler = {
      background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)`
    };
  } else if (noBackground && !useGradient) {
    styler = { background: backgroundColor };
  } else {
    styler = {};
  }
  let component = null;
  if (!hide) {
    component = (
      <section
        id={anchorName || ''}
        className={
          noBackground
            ? 'component social-section smart-section'
            : 'component social-section'
        }
        style={styler}
        // eslint-disable-next-line react/no-unknown-property
        dataorder={order}
        // eslint-disable-next-line react/no-unknown-property
        datatype={type}
      >
        {!noBackground && (
          <SmartImage
            className={
              campaignType === 'general'
                ? 'heightBackground'
                : 'socialSmartImage'
            }
            slug={slug}
            name={
              campaignType !== 'general'
                ? `190-social${imagePattern}`
                : `190-social${socialNumber}${imagePattern}`
            }
            version={version}
            campaignType={campaignType}
            alt={findAltText(
              `Social Background ${socialNumber}`,
              commonTranslations.socialmediatitle
            )}
          />
        )}
        <div className="mainWidth">
          <div className="social-textholder">
            <h2 className={classes} style={{ color: displayTitleColor }}>
              {commonTranslations.socialmediatitle}
            </h2>
            <p
              className="social-text text"
              style={{ color: displayTextColor }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: commonTranslations.instagramtextnew
              }}
            />

            <div className="social-iconholder">
              <a href={commonTranslations.youtubelink}>
                <svg
                  alt="unisport youtube icon"
                  id="elements_social-youtube.svg"
                  data-name="elements/social-youtube.svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width={60}
                  height={60}
                  viewBox="0 0 60 60"
                >
                  <path
                    className="cls-1"
                    fill={outerColor}
                    d="M4232,1870a30,30,0,1,1-30-30A30,30,0,0,1,4232,1870Z"
                    transform="translate(-4172 -1840)"
                  />
                  <path
                    className="cls-2"
                    fill={innerColor}
                    d="M4202.01,1857.99H4202s-7.56,0-12.61.36a5.237,5.237,0,0,0-3.61,1.51,7.627,7.627,0,0,0-1.43,3.53,52.917,52.917,0,0,0-.36,5.75v2.7a53.161,53.161,0,0,0,.36,5.75,7.627,7.627,0,0,0,1.43,3.53,6.239,6.239,0,0,0,3.98,1.52c2.88,0.27,12.25.35,12.25,0.35h0s7.57-.01,12.61-0.37a5.2,5.2,0,0,0,3.61-1.5,7.627,7.627,0,0,0,1.43-3.53,53.161,53.161,0,0,0,.36-5.75v-2.7a52.917,52.917,0,0,0-.36-5.75,7.627,7.627,0,0,0-1.43-3.53,5.221,5.221,0,0,0-3.61-1.51c-5.04-.36-12.61-0.36-12.61-0.36m-3.72,17.11,9.73-4.97-9.74-5.01Z"
                    transform="translate(-4172 -1840)"
                  />
                </svg>
              </a>
              <a href={commonTranslations.instagramlinks}>
                <svg
                  alt="unisport instagram icon"
                  id="elements_social-instagram.svg"
                  data-name="elements/social-instagram.svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width={60}
                  height={60}
                  viewBox="0 0 60 60"
                >
                  <path
                    className="cls-1"
                    fill={outerColor}
                    d="M4132,1870a30,30,0,1,1-30-30A30,30,0,0,1,4132,1870Z"
                    transform="translate(-4072 -1840)"
                  />
                  <path
                    className="cls-2"
                    fill={innerColor}
                    d="M4102,1855.24c4.81,0,5.38.02,7.27,0.11a9.928,9.928,0,0,1,3.35.62,5.89,5.89,0,0,1,3.41,3.41,9.928,9.928,0,0,1,.62,3.35c0.09,1.89.11,2.46,0.11,7.27s-0.02,5.37-.11,7.27a9.928,9.928,0,0,1-.62,3.35,5.447,5.447,0,0,1-1.34,2.06,5.508,5.508,0,0,1-2.07,1.35,9.928,9.928,0,0,1-3.35.62c-1.89.09-2.46,0.11-7.27,0.11s-5.38-.02-7.27-0.11a9.928,9.928,0,0,1-3.35-.62,5.508,5.508,0,0,1-2.07-1.35,5.447,5.447,0,0,1-1.34-2.06,9.928,9.928,0,0,1-.62-3.35c-0.09-1.9-.11-2.46-0.11-7.27s0.02-5.38.11-7.27a9.928,9.928,0,0,1,.62-3.35,5.89,5.89,0,0,1,3.41-3.41,9.928,9.928,0,0,1,3.35-.62c1.89-.09,2.46-0.11,7.27-0.11m0-3.24c-4.89,0-5.5.02-7.42,0.11a13.124,13.124,0,0,0-4.37.83,9.239,9.239,0,0,0-5.27,5.27,13.382,13.382,0,0,0-.83,4.37c-0.09,1.92-.11,2.53-0.11,7.42s0.02,5.5.11,7.42a13.438,13.438,0,0,0,.83,4.37,9.184,9.184,0,0,0,5.27,5.26,13.1,13.1,0,0,0,4.37.84c1.92,0.09,2.53.11,7.42,0.11s5.5-.02,7.42-0.11a13.1,13.1,0,0,0,4.37-.84,8.845,8.845,0,0,0,3.19-2.07,8.715,8.715,0,0,0,2.07-3.19,13.149,13.149,0,0,0,.84-4.37c0.09-1.92.11-2.53,0.11-7.42s-0.02-5.5-.11-7.42a13.1,13.1,0,0,0-.84-4.37,8.715,8.715,0,0,0-2.07-3.19,8.875,8.875,0,0,0-3.19-2.08,13.124,13.124,0,0,0-4.37-.83c-1.92-.09-2.53-0.11-7.42-0.11h0Zm0,8.76a9.24,9.24,0,1,0,9.24,9.24A9.231,9.231,0,0,0,4102,1860.76Zm0,15.24a6,6,0,1,1,6-6A6,6,0,0,1,4102,1876Zm11.77-15.61a2.16,2.16,0,1,1-2.16-2.16A2.164,2.164,0,0,1,4113.77,1860.39Z"
                    transform="translate(-4072 -1840)"
                  />
                </svg>
              </a>
              <a href={commonTranslations.facebooklink}>
                <svg
                  alt="unisport facebook icon"
                  id="elements_social-facebook.svg"
                  data-name="elements/social-facebook.svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width={60}
                  height={60}
                  viewBox="0 0 60 60"
                >
                  <path
                    className="cls-1"
                    fill={outerColor}
                    d="M4332,1870a30,30,0,1,1-30-30A30,30,0,0,1,4332,1870Z"
                    transform="translate(-4272 -1840)"
                  />
                  <path
                    className="cls-2"
                    fill={innerColor}
                    d="M4304.36,1887.6v-16.43h5.52l0.83-6.4h-6.35v-4.08c0-1.86.51-3.12,3.17-3.12h3.4v-5.73a45.163,45.163,0,0,0-4.95-.25c-4.9,0-8.25,2.98-8.25,8.46v4.72h-5.54v6.4h5.54v16.43h6.63Z"
                    transform="translate(-4272 -1840)"
                  />
                </svg>
              </a>
              <a href={commonTranslations.tiktoklink}>
                <svg
                  alt="unisport tiktok icon"
                  id="elements_social-tiktok.svg"
                  data-name="elements/social-tiktok.svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width={60}
                  height={60}
                  viewBox="0 0 100 100"
                >
                  <circle
                    className="cls-1"
                    fill={outerColor}
                    cx="50"
                    cy="50"
                    r="50"
                  />
                  <path
                    className="cls-2"
                    fill={innerColor}
                    d="M77.12,44.43c-5.33,0.01-10.53-1.65-14.87-4.75v21.65c0,10.87-8.82,19.69-19.7,19.68s-19.69-8.82-19.68-19.7
    c0-10.87,8.82-19.69,19.7-19.68c0.9,0,1.8,0.06,2.7,0.19V52.7c-4.76-1.5-9.84,1.15-11.33,5.91s1.15,9.84,5.91,11.33
    c4.76,1.5,9.84-1.15,11.33-5.91c0.28-0.88,0.42-1.79,0.42-2.71V19h10.66c-0.01,0.9,0.07,1.8,0.23,2.69l0,0
    c0.75,4,3.11,7.51,6.53,9.72c2.41,1.59,5.23,2.44,8.12,2.44V44.43z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return !isBootroom ? component : null;
}

export default Social;
